import React from "react";
import { useNavigate } from "react-router-dom";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";

export default function DigiitPage() {
  const navigate = useNavigate();

  const DigiitContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'DIGIIT_CONTENT') : null;
  const AboutDigiitContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ABOUT_DIGIIT_CONTENT') : null;
  const ImapactWallContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'IMPACT_WALL_CONTENT') : null;


  return (
    <div className="min-h-screen font-sans text-gray-900 bg-white">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-gray-50 to-blue-50 py-28 px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-6">
          {DigiitContent && DigiitContent[0]?.title ? (
            (() => {
              const titleWords = DigiitContent[0].title.split(' ');
              const middle = Math.floor(titleWords.length / 2);
              const firstHalf = titleWords.slice(0, middle).join(' ');
              const secondHalf = titleWords.slice(middle).join(' ');
              return (
                <>
                  <span className="text-primary">{firstHalf} </span>
                  <span className="text-black">{secondHalf}</span>
                </>
              );
            })()
          ) : (
            <>
              <span className="text-orange-600">Welcome to </span>
              <span className="text-black">DIGIIT.Ai</span>
            </>
          )}
          {/* Welcome to <span className="text-primary">DIGIIT.Ai</span> */}
        </h1>
        <p className="max-w-2xl mx-auto text-lg md:text-xl text-gray-600 mb-10">
          {DigiitContent && DigiitContent[0]?.subTitle
            ? DigiitContent[0].subTitle
            : "Powering India's Digital Platform Ecosystem with DPI innovation."}
          {/* Powering India's Digital Platform Ecosystem with DPI innovation. */}
        </p>
        <div className="flex justify-center flex-wrap gap-4">
          <button
            onClick={() => navigate("/ventures")}
            className="bg-primary hover:bg-primary-dark text-white px-8 py-3 rounded-lg font-medium shadow-lg transition"
          >
            {DigiitContent && DigiitContent[0]?.description
              ? DigiitContent[0].description
              : "Explore ONE Ventures"}
            {/* Explore ONE Ventures */}
          </button>
          <button
            onClick={() => navigate("/partner-view")}
            className="border border-primary text-primary hover:bg-primary hover:text-white px-8 py-3 rounded-lg font-medium shadow-lg transition"
          >
            {DigiitContent && DigiitContent[1]?.description
              ? DigiitContent[1].description
              : "Partner With Us"}
          </button>
        </div>
      </section>

      {/* About Section */}
      <section className="py-24 px-6 max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-gray-800 mb-6">
          {AboutDigiitContent && AboutDigiitContent[0]?.title ? (
            (() => {
              const titleWords = AboutDigiitContent[0].title.split(' ');
              const middle = Math.floor(titleWords.length / 2);
              const firstHalf = titleWords.slice(0, middle).join(' ');
              const secondHalf = titleWords.slice(middle).join(' ');
              return (
                <>
                  <span className="text-primary">{firstHalf} </span>
                  <span className="text-black">{secondHalf}</span>
                </>
              );
            })()
          ) : (
            <>
              <span className="text-orange-600">About </span>
              <span className="text-black">DIGIIT.Ai</span>
            </>
          )}
          {/* About DIGIIT.Ai */}
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed">
          {DigiitContent && DigiitContent[0]?.subTitle
            ? DigiitContent[0].subTitle
            : "DIGIIT.Ai is a DPI-native technology company helping entrepreneurs and enablerstransform into platform businesses through structured memberships, curated programs,and national-scale opportunities."}
          {/* DIGIIT.Ai is a DPI-native technology company helping entrepreneurs and enablers
          transform into platform businesses through structured memberships, curated programs,
          and national-scale opportunities. */}
        </p>
      </section>

      {/* Track Highlights */}
      <section className="py-24 px-6 bg-gray-100 max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              title: "ONE Ventures",
              desc: "Empowering DPI-based entrepreneurs with tools, training & revenue tracks.",
              btn: "Explore",
              nav: "/ventures"
            },
            {
              title: "ONE Partners",
              desc: "Join us to promote, implement & earn through our partner programs.",
              btn: "Join",
              nav: "/partner-view"
            },
            {
              title: "ONE Catalyst",
              desc: "Trainers, mentors & corporates supporting the ecosystem from behind the scenes.",
              btn: "Join as Catalyst",
              nav: "/catalyst"
            }
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition duration-300 text-center"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-3">{item.title}</h3>
              <p className="text-sm text-gray-600 mb-4">{item.desc}</p>
              <button
                onClick={() => navigate(item.nav)}
                className="text-primary hover:underline font-medium"
              >
                {item.btn}
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Impact Wall */}
      <section className="py-24 px-6 max-w-6xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-gray-800 mb-10">
          {ImapactWallContent && ImapactWallContent[0]?.title ? (
            (() => {
              const titleWords = ImapactWallContent[0].title.split(' ');
              const middle = Math.floor(titleWords.length / 2);
              const firstHalf = titleWords.slice(0, middle).join(' ');
              const secondHalf = titleWords.slice(middle).join(' ');
              return (
                <>
                  <span className="text-primary">{firstHalf} </span>
                  <span className="text-black">{secondHalf}</span>
                </>
              );
            })()
          ) : (
            <>
              <span className="text-orange-600">Impact </span>
              <span className="text-black">Wall</span>
            </>
          )}
          {/* Impact Wall */}
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          <p className="italic text-gray-700 mb-3">
            {ImapactWallContent && ImapactWallContent[0]?.subTitle
              ? ImapactWallContent[0].subTitle
              : "“I launched my DPI business with zero tech experience — now I serve 500+ customers monthly.”"}
            {/* “I launched my DPI business with zero tech experience — now I serve 500+ customers monthly.”   */}
          </p>
          <p className="text-sm font-medium text-gray-500">
            {ImapactWallContent && ImapactWallContent[1]?.subTitle
              ? ImapactWallContent[1].subTitle
              : "“ As a mentor, I’ve guided 30+ women entrepreneurs to digitize and scale.”"}
            {/* “ As a mentor, I’ve guided 30+ women entrepreneurs to digitize and scale.” */}
          </p>
          <p className="italic text-gray-700 mb-3">
            {ImapactWallContent && ImapactWallContent[2]?.subTitle
              ? ImapactWallContent[2].subTitle
              : "“Being a Partner helped me onboard 10 MSMEs and earn commission while empowering others.”"}
            {/* “Being a Partner helped me onboard 10 MSMEs and earn commission while empowering others.” */}
          </p>
          <p className="text-sm font-medium text-gray-500">
            {ImapactWallContent && ImapactWallContent[0]?.description
              ? ImapactWallContent[0].description
              : "Digital Agri Vendor"}
            {/* Digital Agri Vendor */}
          </p>
          <p className="italic text-gray-700 mb-3">
            {ImapactWallContent && ImapactWallContent[1]?.description
              ? ImapactWallContent[1].description
              : "State Partner"}
            {/* State Partner */}
          </p>
          <p className="text-sm font-medium text-gray-500">
            {ImapactWallContent && ImapactWallContent[1]?.description
              ? ImapactWallContent[1].description
              : "ONE Catalyst Mentor"}
            {/* ONE Catalyst Mentor */}
          </p>

        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 px-6 bg-gray-100">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-10">Contact Us</h2>
        <form className="max-w-xl mx-auto bg-white p-8 rounded-lg shadow space-y-6">
          <input
            type="text"
            placeholder="Your Name"
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary"
            required
          />
          <input
            type="email"
            placeholder="Your Email"
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary"
            required
          />
          <textarea
            placeholder="Your Message"
            rows={5}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary"
            required
          ></textarea>
          <button
            type="submit"
            className="w-full bg-primary hover:bg-primary-dark text-white px-6 py-3 rounded-lg transition font-medium"
          >
            Send Message
          </button>
        </form>
      </section>
    </div>
  );
}
